import React from "react"
import "./footer.css"

class FooterComponent extends React.Component {
    render() {
        return (
            <footer>
                <p>Copyright© 2021 CPN TRANSPORT CO.,LTD.</p>
            </footer>
        )
    }
}

export default FooterComponent
